import React from 'react';
import LoginForm from './LoginForm';
import styles from './LoginFormCont.module.css';

const LoginFormCont = () => (
  <div className={styles['login-container']}>
    <header className={styles.header}>
      <h3 className={styles.title}>Instant access. Fewcents</h3>
      <p className={styles.des}>
        No need to subscribe. Pay-per-content across multiple sites.
      </p>
      <h3 className={styles['email-header']}>Email Login</h3>
      <hr />
    </header>
    <section>
      <LoginForm />
    </section>
  </div>
);

export default LoginFormCont;
